<ng-container *ngIf="opened">
  <kendo-dialog [title]="titleLabel | localizeLabel" (close)="cancel()" [width]="640">
    <div class="bo-info-text" [innerHtml]="confirmationLabel | localizeLabel"></div>
    <ul>
      <li *ngFor="let productSpecialFeature of productSpecialFeatures">
        <div class="bo-info-text mb-10" [innerHtml]="productSpecialFeature.Value | formatNewLinesForInnerHtml"></div>
      </li>
    </ul>
    <kendo-dialog-actions class="modal-buttons flex-column flex-md-row">
      <div class="left-column w-100-mobile">
        <a
          (click)="cancel()"
          [innerHtml]="referenceDataLabels.CancelId | localizeLabel"
          class="link vo-secondary-button-1 w-100-mobile mb-15 mb-md-0"
        ></a>
      </div>
      <div class="right-column">
        <button
          (click)="confirm()"
          [innerHtml]="confirmationButtonLabel | localizeLabel"
          class="primary-button vo-primary-button-1"
        ></button>
      </div>
    </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>
